import React from 'react';
import { DotSlider } from '../../../ui/components/DotSlider';

interface DotRatingControlProps {
    value: number;
    onChange: (value: number) => void;
    required?: boolean;
    label: string;
    weight: number;
    reversed?: boolean;
}

const formatLabel = (label: string): string => {
    return label
        .replace(/-/g, ' ')
        .replace(/\b\w/g, c => c.toUpperCase());
};

export const DotRatingControl: React.FC<DotRatingControlProps> = ({
    value,
    onChange,
    required = false,
    label,
    weight,
    reversed = false,
}) => {
    return (
        <div className="space-y-1.5">
            <div className="flex items-center justify-between">
                <label className="text-sm font-medium flex items-center gap-1.5">
                    <span>{formatLabel(label)}</span>
                    {required && <span className="text-pink text-xs">*</span>}
                </label>
                <span className={`text-xs font-semibold tabular-nums px-2 py-0.5 rounded-full ${
                    value > 0
                        ? value >= 8 ? 'bg-emerald-100 text-emerald-700'
                            : value >= 5 ? 'bg-amber-100 text-amber-700'
                            : 'bg-red-100 text-red-700'
                        : 'bg-gray-100 text-gray-400'
                }`}>
                    {value > 0 ? `${value}/10` : '—'}
                </span>
            </div>
            <DotSlider
                value={value}
                onValueChange={onChange}
                min={1}
                max={10}
                reversed={reversed}
            />
        </div>
    );
};

